import React from 'react';

import LoadingBar from 'compositions/LoadingBar';
import Logo from 'compositions/Logo';

import Controls from './Controls';
import TopNavWrapper from './Wrapper';

function TopNav() {
  return (
    <TopNavWrapper id="top-nav">
      <Logo />
      <Controls />
      <LoadingBar />
    </TopNavWrapper>
  );
}

export default TopNav;



// WEBPACK FOOTER //
// ./components/TopNav/index.js